import type { FaireProductEntity } from "../../entity_types/product";

export const p_t577zz9ycm: FaireProductEntity = {
  token: "p_t577zz9ycm",
  type: "product",
  name: "Cocomoi Body Mist",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/64c5a58a02194769c36507fce051f546178dd4451e37c3d01d91716649971eff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e307a7d709d48a81729a517a2bc9c6466b8261ede653954755e895efe0752f3.jpeg",
    "https://cdn.faire.com/fastly/4f8a4a8a4ca849c11ca9901b705b5e3eb7eb8222de7815db98264203d3a6d972.jpeg",
    "https://cdn.faire.com/fastly/6c3c23dafa5b1850f01a80834e83197788960f4b503ffc7ed1c7b9add3306172.jpeg",
    "https://cdn.faire.com/fastly/f09e9eb427b3ebac46c94dda0c8664cf9baac32448d345d2b2d6618a21b9d148.jpeg",
  ],
  priceDollars: 20.9,
  description:
    "Refresh your senses with Homecourt’s Luxury Body Mist, a delicate fine fragrance spray designed to envelop skin in a light yet lasting scent. Perfect for a midday pick-me-up or as an added layer to your fragrance routine, this refreshing body mist offers a subtle, buildable aroma that lingers beautifully throughout the day.\n\nCrafted with eco-friendly, sustainably sourced ingredients, it combines luxury scent with mindful design—making it an effortless way to elevate your everyday ritual.\n\n𝐖𝐡𝐲 𝐘𝐨𝐮’𝐥𝐥 𝐋𝐨𝐯𝐞 𝐈𝐭\n• Fine fragrance body mist with a light, refreshing touch\n• Buildable scent—reapply for adjustable intensity\n• Made with eco-friendly, sustainable ingredients\n• Lightweight spray for easy, all-day use\n• Long-lasting fragrance that enhances your personal scent wardrobe\n\nCocomoi\nCoconut water, cedarwood, creamy fig, cardamom, vetiver, and black pepper. Warm, grounded, and beach-inspired.\nNotes: Coconut Water, Cedarwood*, Vetiver*, Cardamom*, Black Pepper*\n\n*indicates eco-friendly and/or sustainably sourced ingredients\n\n\n𝐇𝐨𝐰 𝐭𝐨 𝐔𝐬𝐞\nSpray lightly onto skin from a few inches away. Reapply as desired throughout the day for a refreshing burst of fragrance.\n\n𝐒𝐢𝐳𝐞\n3.4 fl oz / 100 ml\n\n𝐏𝐚𝐢𝐫𝐢𝐧𝐠 𝐑𝐞𝐜𝐨𝐦𝐦𝐞𝐧𝐝𝐚𝐭𝐢𝐨𝐧\nLayer with Homecourt’s Body Wash and Body Butter for a complete body care ritual that cleanses, hydrates, and scents skin from morning to night.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:23.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
